/** API origin from Vite env (no trailing slash). */
export function getBackendUrl(): string {
  const raw = import.meta.env.VITE_BACKEND_URL
  if (raw == null || String(raw).trim() === '') {
    return ''
  }
  return String(raw).replace(/\/$/, '')
}
